export default __webpack_public_path__ + "e0f8bfe43c18006ca308cb75f5a55bd7.svg";